<template>
  <div id="inspire" style="max-width: 100%; margin: auto;">
    <div class="ma-auto">
      <div class="d-flex align-center my-4">
        <!-- <h1>1</h1> -->
                <v-btn
                    to="/serviceArchieve"
                    color="transparent"
                    elevation="0"
                >
                  <img
                      src="@/assets/images/icons/chevron-right.svg"
                      style="width: 40px"

                  />
                </v-btn>
        <h3 style="margin-right: -18px;">تاکسی 133</h3>
      </div>
    </div>

    <div class="page-f">
      <div class="col-5" style="max-width: 100%">
      <div id="map"
           style="width: 100%; height: 100%;"></div>
      </div>

      <div style="padding:10px;">
        <h2 style="text-align: center; padding: 20px 0 30px 0; color:rgb(186,143,0)">مشخصات</h2>
           <div class="ShowDataDriverBoxes">
             <h3 >نام مسافر : </h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555 color: #555">{{SearchList.nickname}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>نام ایستگاه : </h3>
             <h3 v-if="SearchList.station_title == ''" style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">وارد نشده</h3>
             <h3 v-if="SearchList.station_title != ''" style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.station_title}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>آدرس مبدا</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.address}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>آدرس مقصد</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.destination}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>زمان شروع سرویس</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.start_time_fa}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>زمان پایان سرویس</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.finish_time_fa}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>هزینه سرویس</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.amount}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>حمل بار</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.cargo_price}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>زمان سرویس</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.noTrafficDuration}} الی {{SearchList.duration}} دقیقه</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>کیلومتر طی شده</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.distance}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>دقیقه توقف</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.stopDuration}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>هزینه توقف</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.stop_price}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>رفت و برگشت</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.hasReturn==1 ? 'می باشد' : 'نمی باشد'}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>هزینه کولر</h3>
             <h3 style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.ac_price}}</h3>
           </div>

           <div class="ShowDataDriverBoxes">
             <h3>توضیحات</h3>
             <h3 v-if="SearchList.description == null" style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">وارد نشده</h3>
             <h3 v-if="SearchList.description != null" style="font-weight: 400; padding-right: 15px; font-size: 1rem ; color: #555">{{SearchList.description}}</h3>
           </div>
        </div>
    </div>
    <SocketListner ref="MySocketListner" />
    <AndroidGeolocation  />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import router from '../router';
import SocketListner from "../components/SocketListner.vue";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import AndroidGeolocation from "../components/AndroidGeolocation.vue";
export default {
  components: {
    SocketListner,
    AndroidGeolocation,
   },
  data(){
    return{
      id : 0,
      userBox : '0',
      SearchList : [],
      marker1: null,
      marker2: null,
      marker3: null,
      map: null,
      dropArea:null,
      marker_add:null,
      time:'',
    }
  },
  computed: {
    ...mapGetters(['baseUrl', "auth"]),
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
      this.getInfo()
      this.mapAction(this.$route.params.id)
      this.toTop()
      this.dropArea = document.getElementById('drop-area');

    setInterval(() => {
      const now = new Date();
      const options = { hour: 'numeric', minute: 'numeric' };
      this.time = now.toLocaleTimeString([], options);
    }, 1000);
  },
  methods:{
    toTop () {
      window.location.href = '#inspire';
    },
    getInfo() {
      this.userBox = JSON.parse(localStorage.getItem('auth'));
    },
    mapCreate(){

      let old_lat=parseFloat(this.SearchList.destination_arr.lat);
      let old_lng=parseFloat(this.SearchList.destination_arr.lng);
      // ================== defult lat lng ======================
      let latitud = old_lat!==''?old_lat:35.688428639754235;
      let langtitud = old_lng!==''?old_lng:51.38988018035889;

      // ================== map options ======================
      let mapOptions = {
        center: [latitud, langtitud],
        zoom: 16,
        fullscreenControl: true,
      };
      this.map = new L.map('map', mapOptions); // Creating a map object
      let layer = new L.TileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png'); // Creating a Layer object
      this.map.addLayer(layer);
    },
    mapAction: function (service_id) {
      let self = this;
      fetch(this.baseUrl + '/service-info?token=' + this.userBox.token + '&public_token=' + this.userBox.public_token + '&uid=' +this.userBox.uid  + '&service_id=' + service_id)
          .then(response => response.json())
          .then(json => {
            // var marker00 = 0
            // var marker11 = 1
            // var marker22 = 2
            self.SearchList = json.data;
            console.log('aaa',json.data);
            // this.map.setView([json.data.origin.lat, json.data.origin.lng], 13);
            this.mapCreate()
            // if ()
            self.marker1 = new L.Marker([json.data.origin.lat, json.data.origin.lng], {
              draggable: false,
              icon: new L.DivIcon({
                iconAnchor: [-7, 55],
                elevation: 0,
                title: "مکان",
                className: 'my-div-icon',
                html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker1.png" width="60px"/>' +
                    '<span class="my-div-span busy"></span></div>',
              })
            });
            self.marker1.addTo(this.map);
            self.marker1.on('dragend', function () {
              let coord = this.marker1.getLatLng();
              let lat = coord.lat;
              let lng = coord.lng;
              this.param.latitude = lat;
              this.param.longitude = lng;
            });

            self.marker2 = new L.Marker([json.data.destination_arr.lat, json.data.destination_arr.lng], {
              draggable: false,
              icon: new L.DivIcon({
                iconAnchor: [-7, 55],
                elevation: 0,
                title: "مکان",
                className: 'my-div-icon',
                html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker2.png" width="60px"/>' +
                    '<span class="my-div-span busy"></span></div>',
              })
            });
            self.marker2.addTo(this.map);
            this.marker2.on('dragend', function () {
              let coord = this.marker2.getLatLng();
              let lat = coord.lat;
              let lng = coord.lng;
              this.param.latitude = lat;
              this.param.longitude = lng;
            });

            if (json.data.second_destination_arr.lat != "") {
              self.marker3 = new L.Marker([json.data.second_destination_arr.lat, json.data.second_destination_arr.lng], {
                draggable: false,
                icon: new L.DivIcon({
                  iconAnchor: [-7, 55],
                  elevation: 0,
                  title: "مکان",
                  className: 'my-div-icon',
                  html: '<div><img style="margin-top:15px;margin-right:5px" class="my-div-image" src="/app/img/marker3.png" width="60px"/>' +
                      '<span class="my-div-span busy"></span></div>',
                })
              });
              self.marker3.addTo(this.map);
              self.marker3.on('dragend', function () {
                let coord = this.marker3.getLatLng();
                let lat = coord.lat;
                let lng = coord.lng;
                self.param.latitude = lat;
                self.param.longitude = lng;
              });
            }
          })
    },
    navigate() {
      this.id = 0;
      this.map.removeLayer(this.marker1);
      this.map.removeLayer(this.marker2);
      this.map.removeLayer(this.marker3);
      router.go(-2);
    }
  }
};
</script>

<style scoped>
.ShowDataDriverBoxes{
  padding: 5px 10px;
  background: rgba(255, 202, 40, 0.05) !important;
  border: 2px dotted rgba(255, 202, 40, .5);
  border-radius: 5px;
  margin-bottom: 20px;
}
.ShowDataDriverBoxes h3{
  margin-bottom: 5px !important;
}
.page-f{

  height: calc(100vh - 116px);
  overflow: auto;
  display: flex;
  flex-direction: column;

}
</style>
